





















import { Component, Emit, Model, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import moment from "moment";

@Component({
    components: {}
})
export default class ChoiceFactorInputDateTime extends Vue {

    @Model('change', {type: String})
    readonly value!: string;

    @Prop({default: () => false, type: Boolean})
    date!: boolean;

    @Prop({default: () => false, type: Boolean})
    time!: boolean;

    private internalDate = ''
    private internalTime = ''


    mounted() {
        if (this.value) {
            this.onValueChange()
        }
    }

    @Watch('value')
    private onValueChange() {
        let date = moment(this.value);
        // console.log(date)
        if(date.isValid()) {
            this.internalDate = date.format("YYYY-MM-DD");
            this.internalTime = date.format("HH:mm")
        }
    }

    @Emit('change')
    private changeDate() {
        let date = moment(this.internalDate);
        if (this.internalTime) {
            let [hours, mins] = this.internalTime.split(':')
            if (hours !== 'NaN') {
                date.hours(Number.parseInt(hours))
            }
            if (mins !== 'NaN') {
                date.minutes(Number.parseInt(mins))
            }
        }
        return date.toISOString()
    }

    private changeTime() {
        if (this.internalDate) {
            this.changeDate()
        }
    }


}
